


























































import { Component, Prop, Watch } from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import DocumentSharing from '@/components/DocumentSharing.vue';
import DocumentPresentation from '@/components/DocumentPresentation.vue';
import ShowSlides from '@/components/simpleSlide/components/ShowSlides.vue';
import deck from '@/store/modules/deck';
import SlideButtons from '@/components/simpleSlide/components/SlideButtons.vue';
import * as api from '@/store/api';

@Component({
  components: {
    SlideButtons,
    DocumentPresentation,
    DocumentSharing,
    ShowSlides,
  },
})
export default class MetaValuation extends CompanyMixin {
  @Prop() readonly doc!: any;
  link: boolean = false;
  linkToggling: boolean = false;

  @Watch('doc', { immediate: true, deep: true })
  async docUpdated() {
    deck.loadDoc(this.doc);
    if (this.linkToggling) {
      return;
    }
    await this.refreshLinkStatus();
  }

  async refreshLinkStatus() {
    try {
      const res = await api.isDocumentLinkShared(this.doc.DocumentId);
      this.link = res.data.shared;
    } catch (error) {
      this.link = false;
    }
  }

  async toggleLink(enabled: boolean) {
    this.linkToggling = true;
    try {
      if (enabled) {
        await api.shareDocumentLink({
          UserId: this.doc.UserIdEx,
          DocumentId: this.doc.DocumentId,
        });
      } else {
        await api.unshareDocumentLink({
          UserId: this.doc.UserIdEx,
          DocumentId: this.doc.DocumentId,
        });
      }
      await this.waitForLinkStatus(enabled);
    } catch (error) {
      this.link = !enabled;
    } finally {
      this.linkToggling = false;
    }
  }

  async waitForLinkStatus(expected: boolean) {
    for (let attempt = 0; attempt < 20; attempt++) {
      try {
        const res = await api.isDocumentLinkShared(this.doc.DocumentId);
        if (res.data.shared === expected) {
          this.link = expected;
          return;
        }
      } catch (error) {
        // projection may not have caught up yet
      }
      await api.sleep(100);
    }
    await this.refreshLinkStatus();
  }

  get agenda(): string[] {
    return [];
  }

  get documentType(): string {
    return this.doc.Data.Type;
  }
}
